import { useQuery } from 'react-query';

import { projectsApi } from 'src/Services/API';

const useFetchProjects = (assetId: string) => {
  return useQuery(
    ['projects', assetId],
    () => projectsApi.projectsControllerFindAll(assetId).then(res => res.data),
    { staleTime: 30 * 1000 }
  );
};

export default useFetchProjects;
